import { deriveChatMediaFileName } from 'cpool-utils';

const ATTACHMENT_PLACEHOLDERS = new Set(['[attachment]', '[Attachment]']);

export const getVisibleChatMediaCaption = (content: string | null | undefined) =>
    content && !ATTACHMENT_PLACEHOLDERS.has(content) ? content : null;

const isOpaqueStorageKey = (basename: string) => basename.startsWith('wamid.') || /^[0-9a-f]{64}$/i.test(basename);

export const getChatDownloadRoute = (chatId: string, mediaKey: string) =>
    `/chat/download?chatId=${chatId}&key=${encodeURIComponent(mediaKey)}`;

export const resolveChatAttachmentDownloadName = ({
    mediaFileName,
    mediaKey,
    mediaType,
    name,
}: {
    mediaFileName?: string | null;
    mediaKey: string;
    mediaType: string;
    name?: string;
}) => {
    if (mediaFileName?.trim()) return mediaFileName.trim();
    if (name && !ATTACHMENT_PLACEHOLDERS.has(name)) return name;

    const basename = mediaKey.split('/').pop() ?? mediaKey;
    if (isOpaqueStorageKey(basename)) {
        return deriveChatMediaFileName({ fallbackId: basename, mediaType });
    }

    return basename;
};
